import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-premiosaniversario',
  templateUrl: './premiosaniversario.component.html',
  styleUrls: ['./premiosaniversario.component.scss']
})
export class PremiosaniversarioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
